import { Provider } from '@angular/core';

import { ModulesService } from '@modules/services/modules.service';
import { MODULES_STORE } from '@modules/stores/modules.store';

export const MODULES_PROVIDERS: Provider[] = [ModulesService, MODULES_STORE];
